__webpack_require__.p = "/el-GR/";